import styled from 'styled-components';

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 28px;
`;

export const Title = styled.h2`
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
  color: ${(props) => props.theme.colors['neutral-100']};
`;

export const SearchBox = styled.div`
  margin-bottom: 20px;
  max-width: 400px;
  position: relative;
`;

export const SearchInput = styled.input`
  width: 100%;
  height: 48px;
  padding: 10px 14px 10px 40px;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors['neutral-90']};
  background-color: ${({ theme }) => theme.colors['neutral-20']};
  border: 2px solid transparent;
  border-radius: 8px;
  outline: none;
  transition: border-color 200ms cubic-bezier(0.2, 0.8, 0.4, 1), background-color 200ms cubic-bezier(0.2, 0.8, 0.4, 1);

  &::placeholder {
    color: ${({ theme }) => theme.colors['neutral-50']};
  }

  &:focus {
    border-color: ${({ theme }) => theme.colors['primary-60']};
    background-color: ${({ theme }) => theme.colors['neutral-0']};
  }
`;

export const SearchIcon = styled.span`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: ${({ theme }) => theme.colors['neutral-60']};
  font-size: 16px;
  pointer-events: none;
  display: flex;
  align-items: center;
`;

export const CountLabel = styled.span`
  display: block;
  margin-bottom: 12px;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors['neutral-60']};
`;

export const PaginationWrapper = styled.div`
  margin-top: 20px;
`;
